import React from 'react';

const NonAuthLayout = ({ children }) => {

    return (
        <div>
            {children}
        </div>
    );
};

export default NonAuthLayout;